export const environment = {
  production: false,
  API_URL: 'https://login.dev.maxbrain.io',
};
